var map = {
	"./SellerBanner.png": 3936,
	"./ai1.png": 9712,
	"./ai2.png": 4747,
	"./assist1.png": 2401,
	"./commission.png": 1844,
	"./commissionbg.png": 2377,
	"./delta.png": 6869,
	"./nestle.png": 6808,
	"./nuskin.png": 6711,
	"./philips.png": 2312,
	"./sale1.png": 7421,
	"./virgin.png": 4360
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1560;